import { useEffect, useRef, useState } from "react";

export default function CustomCursor() {
  const cursorRef = useRef(null);
  const [hidden, setHidden] = useState(true);
  const [hovering, setHovering] = useState(false);
  const [coarse, setCoarse] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches) {
      setCoarse(true);
      return;
    }
    document.documentElement.classList.add("has-custom-cursor");
    const onMove = (e) => {
      setHidden(false);
      if (cursorRef.current) {
        cursorRef.current.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
      }
    };
    const onOver = (e) => {
      const t = e.target;
      if (t.closest("a, button, input, textarea, [role='button'], [data-cursor='hover']")) {
        setHovering(true);
      } else {
        setHovering(false);
      }
    };
    const onLeave = () => setHidden(true);
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);
    document.addEventListener("mouseleave", onLeave);
    return () => {
      document.documentElement.classList.remove("has-custom-cursor");
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      document.removeEventListener("mouseleave", onLeave);
    };
  }, []);

  if (coarse) return null;

  return (
    <div
      ref={cursorRef}
      data-testid="custom-cursor"
      aria-hidden
      className={`fixed top-0 left-0 z-[200] pointer-events-none mix-blend-difference transition-opacity ${
        hidden ? "opacity-0" : "opacity-100"
      }`}
      style={{ transition: "opacity .25s ease" }}
    >
      <div
        className={`relative -translate-x-1/2 -translate-y-1/2 transition-all duration-200 ${
          hovering ? "scale-[1.6]" : "scale-100"
        }`}
        style={{ width: 28, height: 28 }}
      >
        <div className="absolute inset-0 rounded-full border border-white/80" />
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-px bg-white/80" />
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-3 w-px bg-white/80" />
      </div>
    </div>
  );
}
